import { ActionTree } from 'vuex'
import RootState from '@/store/RootState'
import GlobalState from '@/store/modules/global/GlobalState'

export const actions: ActionTree<GlobalState, RootState> = {
  setTheme ({ commit }, theme) {
    commit('setTheme', theme)
  },
  setLanguage ({ commit }, languageCode) {
    commit('setLanguageCode', languageCode)
  },
  setApplication ({ commit }, application) {
    commit('setApplication', application)
  }
}
